import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IModifierGroupsContext, ModifierGroupsContext } from '../../modifierGroupsState/modifierGroupsContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './ModifierGroups.module.scss';

const ModifierGroups: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, modifiersGroups, currentPage, countOfItems } =
		useContext<IModifierGroupsContext>(ModifierGroupsContext);

	return (
		<>
			{modifiersGroups.modifierGroupsCount ? (
				<div className={style.container} data-test="ModifierGroups">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={modifiersGroups.modifierGroupsCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default ModifierGroups;
